<template>
  <div>
    <b-container class="mt-5 mb-5">
      <h1 class="fs-4 font-weight-bold mb-4">Laatste updates</h1>

      <b-alert variant="info" show>
        <font-awesome-icon icon="fa-solid fa-info-circle" class="mr-1" />
        Hier vind je de meest recente updates en verbeteringen. Nieuwe
        wijzigingen worden automatisch toegevoegd zodra ze beschikbaar zijn.
      </b-alert>

      <b-card no-body>
        <b-card-body>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Versie</th>
                <th>Datum</th>
                <th>Omschrijving</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2.84</td>
                <td>16-02-2026</td>
                <td style="max-width: 200px">
                  Paginering en autocomplete toegevoegd aan de pagina “Mijn
                  klanten” voor snellere navigatie en efficiënter zoeken.
                </td>
              </tr>
              <tr>
                <td>2.84</td>
                <td>16-02-2026</td>
                <td style="max-width: 200px">
                  Paginering toegevoegd aan de pagina “Evenementen” en
                  "Evenementen Archief" voor snellere navigatie .
                </td>
              </tr>
              <tr>
                <td>2.84</td>
                <td>16-02-2026</td>
                <td style="max-width: 200px">
                  Nieuwe statistiekenpagina toegevoegd met inzicht in
                  klantgedrag, omzet, leeftijdsverdeling, gender en
                  aankoopmomenten.
                </td>
              </tr>
              <tr>
                <td>2.84</td>
                <td>17-02-2026</td>
                <td style="max-width: 200px">
                  Nieuwe "Alle tickets" pagina toegevoegd aan het Klantenmenu,
                  samen met een verbeterde weergave van “Mijn klanten”.
                </td>
              </tr>
              <tr>
                <td>2.85</td>
                <td>18-02-2026</td>
                <td style="max-width: 200px">
                  Nieuwe functionaliteit toegevoegd om locaties handmatig uit te
                  nodigen voor een teams account.
                </td>
              </tr>
              <tr>
                <td>2.86</td>
                <td>27-02-2026</td>
                <td style="max-width: 200px">
                  Issue opgelost waarbij het ophalen van event data kon falen
                  door ontbrekende relaties.
                </td>
              </tr>
              <tr>
                <td>2.86</td>
                <td>27-02-2026</td>
                <td style="max-width: 200px">
                  Mogelijkheid toegevoegd om direct in te loggen als teamlid
                  vanaf de teamlid wijzigen-pagina.
                </td>
              </tr>
              <tr>
                <td>2.86</td>
                <td>27-02-2026</td>
                <td style="max-width: 200px">
                  "Locatie toevoegen" knop verborgen voor niet-admin gebruikers
                  op evenement edit/create pagina.
                </td>
              </tr>
              <tr>
                <td>2.86</td>
                <td>27-02-2026</td>
                <td style="max-width: 200px">
                  Autorisatiecontrole toegevoegd voor locaties (location-based
                  access restriction).
                </td>
              </tr>
              <tr>
                <td>2.87</td>
                <td>05-03-2026</td>
                <td style="max-width: 200px">
                  Het verwijderen van evenementen die nog niet gepubliceerd
                  zijn, is beschikbaar gemaakt.
                </td>
              </tr>
              <tr>
                <td>2.88</td>
                <td>09-03-2026</td>
                <td style="max-width: 200px">
                  Issue opgelost waarbij afbeeldingen van niet-ondersteunde
                  bestandstypen werden toegestaan.
                </td>
              </tr>
              <tr>
                <td>2.88</td>
                <td>09-03-2026</td>
                <td style="max-width: 200px">
                  Nieuw evenementenoverzicht toegevoegd aan de pagina "Locatie
                  wijzigen". Hierdoor is het nu mogelijk te zien welke
                  evenementen aan de betreffende locatie gekoppeld zijn.
                </td>
              </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-card>
    </b-container>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Laatste updates",
  },
};
</script>
